const initContactForm = () => {
    document.querySelectorAll('.wpcf7-list-item').forEach((item) => {
        const input = item.querySelector('input[type="radio"], input[type="checkbox"]');
        if (input) {
            item.addEventListener('click', (e) => {
                if (e.target !== input) input.click();
            });
        }
    });

    const applicationWrapper = document.querySelector('.application-question');

    if (!applicationWrapper) return;

    const triggers = applicationWrapper.dataset.showFor.split(',');

    const toggle = () => {
        const selected = document.querySelector('input[name="query-type"]:checked');
        const isMa = selected && triggers.includes(selected.value);

        applicationWrapper.style.display = isMa ? '' : 'none';

        applicationWrapper.querySelectorAll('input[name="application-submitted"]').forEach((input) => {
            input.checked = false;
            input.removeAttribute('checked');

            // Set 'N/A' field to checked if not an MA option
            if (input.value === 'N/A' && !isMa) {
                input.checked = true;
                input.setAttribute('checked', '');
            }
        });
    };

    document.querySelectorAll('input[name="query-type"]').forEach((input) => {
        input.addEventListener('change', toggle);
    });

    toggle();
};

export { initContactForm as default };
